import { api } from './client';
import type { User } from './types';

export const authApi = {
  register: (input: { email: string; password: string; name: string }) =>
    api.post<{ user: User; message: string }>('/auth/register', input),

  login: (input: { email: string; password: string }) =>
    api.post<{ user: User }>('/auth/login', input),

  logout: () => api.post<{ message: string }>('/auth/logout'),

  me: () => api.get<{ user: User }>('/auth/me'),

  forgotPassword: (email: string) =>
    api.post<{ message: string }>('/auth/forgot-password', { email }),

  resetPassword: (token: string, newPassword: string) =>
    api.post<{ message: string }>('/auth/reset-password', { token, newPassword }),

  switchOrg: (orgId: string) =>
    api.post<{ message: string }>('/auth/switch-org', { orgId }),
};
